import React from "react";
import "./SwitchCoin.scss";

const SwitchCoin = (props) => {
  return (
    <div className="switch-item">
      <label>coin{props.num} : </label>
      <div className={`btn-checkbox ${props.isSpined && "disabled"}`}>
        <input 
          type="checkbox" 
          className="checkbox"
          name={props.num}
          onChange={(e) => props.change(e)}
          checked={props.status}
        />
        <div className="knobs">
          <span className={props.betType}></span>
        </div>
        <div className="layer"></div>
      </div>
    </div>
  )
}

export default SwitchCoin;